<div class="sidenav" [class.collapsed]="isCollapsed">
	<!-- Logo -->
	<a routerLink="/dashboard" class="nav-logo" (click)="onMenuItemClick()">
		<img src="assets/images/logo.svg" alt="Cryptionis" class="logo-full" />
		<span class="logo-icon"><img src="assets/images/logo.svg" alt="C" /></span>
	</a>

	<!-- Navigation Items — driven by the shared CMS_NAV_ITEMS config (nav.config.ts)
	     so the desktop sidebar and the mobile header can never drift. Add a tab there. -->
	<nav class="nav-items">
		<div class="nav-section">
			@for (item of navItems(); track item.path) {
			<a
				class="nav-item"
				[class.locked]="isLocked(item)"
				(click)="onMenuItemClick()"
				[routerLink]="item.path"
				routerLinkActive="active"
				[attr.title]="isLocked(item) ? ('nav.locked' | translate) : null"
			>
				@if (item.badge === 'investingAlerts') {
				<mat-icon
					[matBadge]="unreadAlerts() > 0 ? unreadAlerts() : null"
					matBadgeColor="warn"
					matBadgeSize="small"
				>
					{{ item.icon }}
				</mat-icon>
				} @else if (item.badge === 'notifications') {
				<mat-icon
					[matBadge]="unreadNotifications() > 0 ? unreadNotifications() : null"
					matBadgeColor="warn"
					matBadgeSize="small"
				>
					{{ item.icon }}
				</mat-icon>
				} @else {
				<mat-icon>{{ item.icon }}</mat-icon>
				}
				<span class="nav-label">
					{{ item.labelKey ? (item.labelKey | translate) : item.label }}
				</span>
				@if (isLocked(item)) {
				<mat-icon class="lock-icon">lock</mat-icon>
				}
			</a>
			}
		</div>

		@if (isAdmin) {
		<div class="nav-divider">
			<span class="nav-divider-label">Admin</span>
		</div>
		<div class="nav-section">
			@for (item of adminItems; track item.path) {
			<a
				class="nav-item"
				(click)="onMenuItemClick()"
				[routerLink]="item.path"
				routerLinkActive="active"
			>
				<mat-icon>{{ item.icon }}</mat-icon>
				<span class="nav-label">
					{{ item.labelKey ? (item.labelKey | translate) : item.label }}
				</span>
			</a>
			}
		</div>
		}
	</nav>

	<!-- Bottom Section -->
	<div class="nav-bottom">
		<button
			type="button"
			class="nav-item nav-item--theme"
			(click)="onThemeToggle()"
			[attr.aria-label]="'nav.toggleTheme' | translate"
		>
			<mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
			<span class="nav-label">{{ 'nav.toggleTheme' | translate }}</span>
		</button>
		<a
			class="nav-item"
			(click)="onMenuItemClick()"
			routerLink="/account/settings"
			routerLinkActive="active"
		>
			<mat-icon>settings</mat-icon>
			<span class="nav-label">Settings</span>
		</a>
		<a class="nav-item nav-item--danger" (click)="onLogoutClick()">
			<mat-icon>logout</mat-icon>
			<span class="nav-label">Logout</span>
		</a>

		<!-- Collapse Toggle (desktop only) -->
		<button class="collapse-toggle" (click)="onCollapseClick()">
			<mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
		</button>
	</div>
</div>
